import React from 'react';
import cx from 'classnames';
import { CountWrapper } from './notificationBadge.style';

export function NotificationBadge({ count }) {
  if (!count) {
    return null;
  }

  const isMaxAmount = count > 99;

  const notificationsCount = isMaxAmount ? '99+' : count;

  return (
    <CountWrapper className={cx({ 'notification-badge': true, 'is-max-amount': isMaxAmount })}>
      {notificationsCount}
    </CountWrapper>
  );
}
